import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44b8d8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-input-group-wrapper"
}
const _hoisted_2 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_3 = { class: "ant-input-group-addon ss-grupo-icone-recurso-destaque" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cadastrar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "ss-informacao-adicional-select ss-tag",
  style: {"background-color":"#a0aec1","border-color":"#a0aec1","color":"#fff","margin-right":"10px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cadastrar", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "ss-informacao-adicional-select ss-tag",
  style: {"background-color":"#a0aec1","border-color":"#a0aec1","color":"#fff","margin-right":"10px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, " Cadastro Rápido de Pessoa ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"flex-grow":"0"}
}
const _hoisted_15 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6",
  style: {"flex-grow":"0"}
}
const _hoisted_16 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-14",
  style: {"flex-grow":"0"}
}
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_carregando = _resolveComponent("campo-carregando")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_selecionar_relacao_pessoa = _resolveComponent("selecionar-relacao-pessoa")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_pessoa_modal = _resolveComponent("pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.apresentacaoPersonalizada)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_icone, {
                class: "ss-icone ss-icone-recurso-destaque",
                nome: _ctx.obterIconePessoa()
              }, null, 8, ["nome"])
            ]),
            _createVNode(_component_a_form_item, {
              label: _ctx.props.label,
              class: "ss-margin-campos",
              rules: [{ required: _ctx.props.required }]
            }, {
              default: _withCtx(() => [
                (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado, _ctx.computedCodigosSelecionados))
                  ? (_openBlock(), _createBlock(_component_campo_carregando, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      mode: _ctx.props.varios?'multiple':null,
                      value: _ctx.props.varios?_ctx.computedCodigosSelecionados:_ctx.computedCodigoSelecionado,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.props.varios?_ctx.computedCodigosSelecionados = $event:_ctx.computedCodigoSelecionado = $event)),
                      onChange: _ctx.change,
                      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarPessoa(''))),
                      onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pesquisarPessoa($event))),
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
                      "show-search": "",
                      optionFilterProp: "label",
                      class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
                      allowClear: _ctx.props.limparSelecao,
                      placeholder: _ctx.props.placeholder,
                      filterOption: false,
                      "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
                      disabled: _ctx.props.disabled,
                      title: _ctx.props.title,
                      "data-coluna": _ctx.props.dataAttributeColuna
                    }, _createSlots({
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (pessoa) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: pessoa.codigo,
                            value: pessoa.codigo,
                            class: _normalizeClass(pessoa.codigo === 0? 'ss-opcao-btn':'')
                          }, {
                            default: _withCtx(() => [
                              (pessoa.codigo === 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cadastrar && _ctx.cadastrar(...args)), ["stop"])),
                                    class: "ant-btn ant-btn-primary ant-btn-sm ss-btn-opcao ss-tamanho-completo",
                                    type: "button"
                                  }, _hoisted_5))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(pessoa.textoIdentificacao) + " ", 1),
                                    (_ctx.props.apresentarRelacoes)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(pessoa.informacaoAdicional), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                            ]),
                            _: 2
                          }, 1032, ["value", "class"]))
                        }), 128))
                      ]),
                      _: 2
                    }, [
                      (_ctx.selecionarBase.buscandoDados)
                        ? {
                            name: "notFoundContent",
                            fn: _withCtx(() => [
                              _createTextVNode(" Buscando Cadastros"),
                              _createVNode(_component_a_spin)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"]))
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado, _ctx.computedCodigosSelecionados))
            ? (_openBlock(), _createBlock(_component_campo_carregando, { key: 0 }))
            : (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                mode: _ctx.props.varios?'multiple':null,
                value: _ctx.props.varios?_ctx.computedCodigosSelecionados:_ctx.computedCodigoSelecionado,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.props.varios?_ctx.computedCodigosSelecionados = $event:_ctx.computedCodigoSelecionado = $event)),
                onChange: _ctx.change,
                onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pesquisarPessoa(''))),
                onSearch: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pesquisarPessoa($event))),
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
                "show-search": "",
                optionFilterProp: "label",
                class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
                allowClear: _ctx.props.limparSelecao,
                placeholder: _ctx.props.placeholder,
                filterOption: false,
                "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
                disabled: _ctx.props.disabled,
                title: _ctx.props.title,
                "data-coluna": _ctx.props.dataAttributeColuna
              }, _createSlots({
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecionarBase.listaItensConsultaRapida, (pessoa) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: pessoa.codigo,
                      value: pessoa.codigo,
                      class: _normalizeClass(pessoa.codigo === 0? 'ss-opcao-btn':'')
                    }, {
                      default: _withCtx(() => [
                        (pessoa.codigo === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cadastrar && _ctx.cadastrar(...args)), ["stop"])),
                              class: "ant-btn ant-btn-primary ant-btn-sm ss-btn-opcao ss-tamanho-completo",
                              type: "button"
                            }, _hoisted_8))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(pessoa.textoIdentificacao) + " ", 1),
                              (_ctx.props.apresentarRelacoes)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(pessoa.informacaoAdicional), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]),
                      _: 2
                    }, 1032, ["value", "class"]))
                  }), 128))
                ]),
                _: 2
              }, [
                (_ctx.selecionarBase.buscandoDados)
                  ? {
                      name: "notFoundContent",
                      fn: _withCtx(() => [
                        _createTextVNode(" Buscando Cadastros"),
                        _createVNode(_component_a_spin)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "disabled", "title", "data-coluna"]))
        ], 64)),
    (_ctx.state.apresentarCadastroRapido)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 2,
          keyboard: false,
          visible: _ctx.state.apresentarCadastroRapido,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.apresentarCadastroRapido) = $event)),
          width: 800,
          centered: ""
        }, {
          title: _withCtx(() => [
            _hoisted_10
          ]),
          closeIcon: _withCtx(() => [
            _createVNode(_component_icone, { nome: "voltar" })
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", null, [
              (!_ctx.state.cadastrandoPessoa)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ant-btn ant-btn-lg ant-btn-primary",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.concluirCadastroRapido()))
                  }, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_spin, {
                  spinning: _ctx.state.cadastrandoPessoa
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, {
                          label: "Documento",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_group, {
                              value: _ctx.state.documentoCpf,
                              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.documentoCpf) = $event)),
                              "button-style": "solid",
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.verificacaoNumero()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: true }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("CPF")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: false }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("CNPJ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, {
                          label: "Número",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.state.documentoCpf)
                              ? (_openBlock(), _createBlock(_component_campo_cpf, {
                                  key: 0,
                                  valor: _ctx.state.cadastroRapido.cpfCnpj,
                                  "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.cadastroRapido.cpfCnpj) = $event))
                                }, null, 8, ["valor"]))
                              : (_openBlock(), _createBlock(_component_campo_cnpj, {
                                  key: 1,
                                  valor: _ctx.state.cadastroRapido.cpfCnpj,
                                  "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.cadastroRapido.cpfCnpj) = $event)),
                                  onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.consultaCNPJ()))
                                }, null, 8, ["valor"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.state.documentoCpf?'Nome':'Razão Social',
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "250",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.cadastroRapido.nomeRazaoSocial) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.cadastroRapido.nomeRazaoSocial]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_form_item, {
                          label: "Relações",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_relacao_pessoa, {
                              varias: true,
                              codigosSelecionados: _ctx.state.cadastroRapido.relacoes,
                              "onUpdate:codigosSelecionados": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.cadastroRapido.relacoes) = $event))
                            }, null, 8, ["codigosSelecionados"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["spinning"])
              ]),
              _: 1
            }),
            _createVNode(_component_requisicao_modal, {
              visivel: _ctx.modalBase.exibirRequisicaoModal,
              "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
              retornoRequisicao: _ctx.modalBase.retornoRequisicao,
              apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
              fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
            }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_ctx.props.apresentarCadastro)
      ? (_openBlock(), _createBlock(_component_pessoa_modal, {
          key: 3,
          relacaoPrincipalOperacao: _ctx.props.tipoRelacao,
          tituloModal: 'Cadastro de ' + _ctx.props.label,
          visivel: _ctx.selecionarBase.apresentarCadastro,
          "onUpdate:visivel": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selecionarBase.apresentarCadastro) = $event)),
          operacao: _ctx.selecionarBase.operacaoCadastro,
          pessoaPreCadastro: _ctx.state.pessoaPreCadastro,
          servicoAPI: _ctx.servicoCadastroPessoa,
          onCadastroConcluido: _cache[21] || (_cache[21] = ($event: any) => (_ctx.cadastroConcluido($event)))
        }, null, 8, ["relacaoPrincipalOperacao", "tituloModal", "visivel", "operacao", "pessoaPreCadastro", "servicoAPI"]))
      : _createCommentVNode("", true)
  ]))
}